export default "__VITE_ASSET__D9Mb4fmA__"